const commissionTypes = {
  RESET_COMMISSIONS_STATE: 'RESET_COMMISSIONS_STATE',
  RESET_COMMISSIONS_MESSAGE: 'RESET_COMMISSIONS_MESSAGE',
  FETCH_COMMISSIONS: {
    REQUEST: 'FETCH_COMMISSIONS.REQUEST',
    SUCCESS: 'FETCH_COMMISSIONS.SUCCESS',
    FAILURE: 'FETCH_COMMISSIONS.FAILURE',
  },
};

export default commissionTypes;
